import React, { useEffect, useState } from "react";
import './ComboBox.css'

function ComboBox({
    setAttribute,
    optionsData,
    style,
    value,
    disabled,
    readOnly,
    placeholder,
    defaultValue,
    className = 'combobox',
    onBlur,
    dropdown = false
}) {

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");


    const handleSelectChange = (lookupChanged, id) => {
        lookupChanged(id);
        setOpen(false);
    }


    const getOptions = () => {
        if (!optionsData) return [];

        const children = Array.isArray(optionsData.props.children)
            ? optionsData.props.children
            : [optionsData.props.children];

        return children
            .flatMap(child => {
                if (!child) return [];
                if (Array.isArray(child)) return child;
                return child;
            })
            .filter(Boolean);
    }


    const getFirstOptionValue = () => {

        const options = getOptions();

        const firstOption = options.find(option =>
            option?.props?.value != null
        );

        return firstOption?.props?.value ?? null;
    }


    const getSelectedLabel = () => {

        const option = getOptions().find(
            option =>
                String(option.props.value) === String(value)
        );

        return option?.props?.children || "";
    }


    let isValueInOptions = false;

    if (optionsData) {

        isValueInOptions = getOptions().some(option =>
            String(option.props.value) === String(value)
        );

    }


    useEffect(() => {

        if ((!value || !isValueInOptions) && optionsData) {

            const firstValue = getFirstOptionValue();

            if (firstValue != null && setAttribute) {
                setAttribute(firstValue);
            }

        }

    }, [value, optionsData]);


    /*
        Dropdown:
        input + lista abaixo + filtro
    */
    if (dropdown) {

        const filteredOptions = getOptions().filter(option =>
            String(option.props.children)
                .toLowerCase()
                .includes(search.toLowerCase())
        );


        return (

            <div
                className="combobox-container"
                style={style}
            >

                <input

                    className={className}

                    value={
                        search !== ""
                            ? search
                            : getSelectedLabel()
                    }

                    placeholder={placeholder}

                    disabled={disabled}

                    readOnly={readOnly}

                    onFocus={() => {
                        setOpen(true);
                    }}

                    onChange={(e) => {

                        setSearch(e.target.value);
                        setOpen(true);

                    }}

                    onBlur={() => {

                        setTimeout(() => {
                            setOpen(false);
                        }, 200);

                        if (onBlur) {
                            onBlur();
                        }

                    }}

                />


                {open && (

                    <div className="combobox-list">

                        {filteredOptions.map(option => (

                            <div

                                key={option.props.value}

                                className="combobox-item"

                                onMouseDown={() => {

                                    handleSelectChange(
                                        setAttribute,
                                        option.props.value
                                    );

                                    setSearch("");

                                }}

                            >

                                {option.props.children}

                            </div>

                        ))}

                    </div>

                )}

            </div>

        );

    }



    /*
        Select normal antigo
    */
    return (

        <select

            className={className}

            onChange={(e) =>
                handleSelectChange(
                    setAttribute,
                    e.target.value
                )
            }

            value={
                isValueInOptions
                    ? value
                    : ''
            }

            disabled={disabled}

            readOnly={readOnly}

            style={{
                ...style,
                cursor: 'pointer'
            }}

            defaultValue={
                isValueInOptions
                    ? defaultValue
                    : ''
            }

            onBlur={onBlur}

        >

            {placeholder &&

                <option
                    value=""
                    disabled
                    hidden
                >
                    {placeholder}
                </option>

            }


            {optionsData}

        </select>

    );

}

export default ComboBox;
